import { useEffect, useState } from "react";

import "./styles/index.scss";

import { useRoutes, type RouteObject } from "react-router-dom";
import { adminRoutes, routes } from "router";
import { ConfigProvider, Spin } from "antd";
import { useRouter } from "hooks/useRouter";
import { userStore } from "store/userStore";
import { observer } from "mobx-react";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { viVNLocale } from "utils/locale";

const App = observer(() => {
  const element = useRoutes(routes as RouteObject[]);
  const [isLoaded, setIsLoaded] = useState(false);
  useRouter(isLoaded);

  useEffect(() => {
    handleInit();
  }, []);

  const handleInit = async () => {
    try {
      if (userStore.token) {
        await userStore.getProfile();
        permissionStore.accessRoutes = [...adminRoutes];
        if (settings.checkPermission && userStore.info.role) {
          await permissionStore.fetchPermissions(userStore.info.role.id);
          permissionStore.setAccessRoutes();
        }
      }
    } catch (error) {
      userStore.logout();
    } finally {
      setIsLoaded(true);
    }
  };

  return (
    <ConfigProvider locale={viVNLocale}>
      {isLoaded ? (
        <div className="App app-ant-design-system">{element}</div>
      ) : (
        <div
          className="loading"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      )}
    </ConfigProvider>
  );
});

export default App;
